<template>
    <grades-chart :inline="false" :data="courses" />
</template>

<script>
export default {
  props: {
    courses: {
      type: Array,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/user/grades.vue